export default __webpack_public_path__ + "static/media/active-eye-orange.78bb5627.svg";